/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-custom-event-conversion-type',
  template: `@if (conversionType) { <span>{{ ('customEvent.conversionType.' + conversionType) | ogTranslate }}</span> }`
})
export class CustomEventConversionTypeLabelComponent {
  @Input() conversionType: string;
}
